import script from "./InfoPlazaPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoPlazaPage.vue?vue&type=script&setup=true&lang=ts"

import "./InfoPlazaPage.scss?vue&type=style&index=0&lang=scss&external"
import "../../components/portal/staffEditor.scss?vue&type=style&index=1&lang=scss&external"

const __exports__ = script;

export default __exports__